<template>
  <div id="app">
    <header class="app-header">
      <router-link to="/" class="brand">
        <span class="brand-logo">收</span>
        <span class="brand-name">收款商城</span>
      </router-link>
      <router-link to="/" class="nav-link">首页</router-link>
    </header>
    <main class="app-main">
      <router-view/>
    </main>
    <footer class="app-footer">收款商城 · 安全支付</footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --primary: #4f7cff;
  --primary-hover: #3b66e8;
  --gradient: linear-gradient(135deg, #4f7cff 0%, #7b5bff 100%);
  --price: #ff5c00;
  --text-main: #1f2329;
  --text-sub: #646a73;
  --text-light: #8f959e;
  --bg: #f6f7fb;
  --card-bg: #ffffff;
  --radius: 16px;
  --shadow: 0 6px 24px rgba(31, 35, 41, 0.08);
  --shadow-hover: 0 12px 36px rgba(79, 124, 255, 0.18);
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--bg);
  color: var(--text-main);
  min-height: 100vh;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 60px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(31, 35, 41, 0.06);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.brand-logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--gradient);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(79, 124, 255, 0.35);
}

.brand-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-main);
  letter-spacing: 0.5px;
}

.nav-link {
  color: var(--text-sub);
  text-decoration: none;
  font-size: 14px;
  padding: 6px 16px;
  border-radius: 20px;
  transition: all 0.2s;
}

.nav-link:hover {
  color: var(--primary);
  background: rgba(79, 124, 255, 0.08);
}

.app-main {
  flex: 1;
}

.app-footer {
  text-align: center;
  padding: 20px;
  color: var(--text-light);
  font-size: 12px;
}
</style>
